/*
 * @Author: Latte
 * @Date: 2021-08-05 16:39:39
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-01 23:12:30
 * @FilePath: \Siui.Cloud.Medical.Web\src\config\tableConfig\diagnosticTeam.js
 */

/**
 * 首页表格配置项
 * 
 * 完整配置
 *  prop  单元格数据（非特殊类型必填）
    label  单元格标题（非特殊类型必填）
    type  类型
    width  宽度
    header-align 表头位置
    align  内容位置
 */

// 会诊团队表格配置
export const diagnosticTeamConf = Object.freeze({
	tableColumnOpt: [
		{
			label: "访问权限",
			width: "150",
			prop: "stringAccessAuthority",
		},
		{
			label: "团队 ID",
			width: "100",
			prop: "teamID",
		},
		{
			label: "团队名称",
			width: "150",
			prop: "teamName",
		},
		{
			label: "团队成员数量",
			width: "100",
			prop: "teamUserCount",
		},
		{
			label: "所属地点",
			width: "250",
			prop: "fullPlace",
		},
	],
	hasStatus: true,
	hasOperation: true,
	operationWidth: "600",
});
